import React from 'react'
import PropTypes from 'prop-types'
import './PpeItem.module.scss'

const PpeItem = ({ title, description }) => (
  <div styleName='item'>
    <h4 styleName='title'>{title}</h4>
    <p styleName='description'>{description}</p>
  </div>
)

PpeItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}

export default PpeItem



// WEBPACK FOOTER //
// ./src/components/PpeItemList/PpeItem/PpeItem.js